export default function Status({ status }: { status: string }) {

  const statusColor = {
    pending: "#FFC107",
    completed: "#4CAF50",
    cancelled: "#F44336",
    "in progress": "#FFC107",
    "in review": "#FFC107",
    paid: "#4CAF50",
    unpaid: "#F44336",
    refunded: "#F44336",
  }

  return (
    <div className="flex justify-center">
      <div className="text-white px-3 py-1 rounded-3xl text-sm w-fit" style={{
        backgroundColor: statusColor[status as keyof typeof statusColor] || "#FFC107"
      }}>
        {status}
      </div>
    </div>
  )
}